import { PdfSplitProgressMessage, PdfSplitStatus } from 'editor/src/store/gallery/types';

const STATUSES: PdfSplitStatus[] = ['splitting', 'saving', 'done', 'failed'];

const isOptionalCount = (value: unknown) =>
  value === undefined || (typeof value === 'number' && Number.isInteger(value) && value >= 0);

const isOptionalPageImageIds = (value: unknown) =>
  value === undefined || (Array.isArray(value) && value.every((id) => id === null || typeof id === 'string'));

// Host messages carry no types at runtime; a malformed one would reach the Files tab's rendering and Fill.
// Only the known fields are kept, so a host cannot set editor-owned state such as a closed notice.
const parsePdfSplitProgressMessage = (data: unknown): PdfSplitProgressMessage | undefined => {
  if (!data || typeof data !== 'object') {
    return undefined;
  }

  const { uploaderId, fileName, status, pagesTotal, pagesSaved, pageImageIds } = data as Record<string, unknown>;
  if (
    typeof uploaderId !== 'string' ||
    !uploaderId ||
    typeof fileName !== 'string' ||
    !STATUSES.includes(status as PdfSplitStatus) ||
    !isOptionalCount(pagesTotal) ||
    !isOptionalCount(pagesSaved) ||
    !isOptionalPageImageIds(pageImageIds)
  ) {
    return undefined;
  }

  return {
    uploaderId,
    fileName,
    status: status as PdfSplitStatus,
    ...(pagesTotal !== undefined ? { pagesTotal: pagesTotal as number } : {}),
    ...(pagesSaved !== undefined ? { pagesSaved: pagesSaved as number } : {}),
    ...(pageImageIds !== undefined ? { pageImageIds: pageImageIds as (string | null)[] } : {}),
  };
};

export default parsePdfSplitProgressMessage;
